import { mapSelbstbeteiligung } from '@ps20-frontend/migrations';
import { VertragsoptionenVHV } from '../model/vertragsoptionen.model';
import { StatePreV6, StateV6 } from './6_migrate_selbstbeteiligung.interface';

export const migrateSelbstbeteiligung = (
  previousState: StatePreV6,
  newVersion: number,
): StateV6 => {
  return {
    ...previousState,
    version: newVersion,
    vertragsoptionen: {
      ...previousState.vertragsoptionen,
      selbstbeteiligung: mapSelbstbeteiligung(previousState.vertragsoptionen.selbstbeteiligung),
    } as VertragsoptionenVHV,
  };
};
